import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { SignInButton } from "./SignInButton";
import { InteractionStatus } from "@azure/msal-browser";
import styles from "./Login.module.less";
import SignOutButton from "./SignOutButton";

const SignInSignOutButton = () => {
  const { inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  if (isAuthenticated) {
    return <SignOutButton />;
  } else if (
    inProgress !== InteractionStatus.Startup &&
    inProgress !== InteractionStatus.HandleRedirect
  ) {
    // inProgress check prevents sign-in button from being displayed briefly after returning from a redirect sign-in. Processing the server response takes a render cycle or two
    return (
      <div className={styles.wrapperButton}>
        {" "}
        <SignInButton />
      </div>
    );
  } else {
    return null;
  }
};

export default SignInSignOutButton;
